import type { Profil } from './types';

/**
 * Qui lit le résultat EVA d'un dossier (TF-441) : le pôle pédagogique,
 * assistant(e) de site compris(e), et la direction. Les autres pôles ouvrent le
 * dossier sans lui : un repérage de l'illettrisme n'a d'usage que pour
 * l'accompagnement. La garde qui compte est `exigerProfil` côté serveur ; cette
 * liste évite de monter une carte que l'API refuserait.
 */
export function peutLireEva(profil: Profil | undefined): boolean {
  return profil === 'PEDAGOGIQUE' || profil === 'DIRECTION';
}
